module.exports = __webpack_public_path__ + "img/setting-active.84541427.svg";